import React, { memo } from "react";

interface IProps {
  customClass: string;
}

const GlassIcon: React.FC<IProps> = memo(({ customClass }) => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
    >
      <path
        d="M10.8409 12.3122L7.02273 8.48862C6.68182 8.76173 6.28977 8.97795 5.84659 9.13727C5.40341 9.29659 4.93182 9.37624 4.43182 9.37624C3.19318 9.37624 2.145 8.94677 1.28727 8.08782C0.429091 7.22842 0 6.17852 0 4.93812C0 3.69772 0.429091 2.64782 1.28727 1.78842C2.145 0.929474 3.19318 0.5 4.43182 0.5C5.67045 0.5 6.71886 0.929474 7.57705 1.78842C8.43477 2.64782 8.86364 3.69772 8.86364 4.93812C8.86364 5.43883 8.78409 5.91109 8.625 6.35491C8.46591 6.79872 8.25 7.19132 7.97727 7.53272L11.8125 11.3734C11.9375 11.4986 12 11.6522 12 11.8343C12 12.0164 11.9318 12.1757 11.7955 12.3122C11.6705 12.4374 11.5114 12.5 11.3182 12.5C11.125 12.5 10.9659 12.4374 10.8409 12.3122ZM4.43182 8.01067C5.28409 8.01067 6.00864 7.71206 6.60545 7.11485C7.20182 6.51718 7.5 5.79161 7.5 4.93812C7.5 4.08464 7.20182 3.35906 6.60545 2.76139C6.00864 2.16418 5.28409 1.86558 4.43182 1.86558C3.57955 1.86558 2.855 2.16418 2.25818 2.76139C1.66182 3.35906 1.36364 4.08464 1.36364 4.93812C1.36364 5.79161 1.66182 6.51718 2.25818 7.11485C2.855 7.71206 3.57955 8.01067 4.43182 8.01067Z"
        fill="currentColor"
      />
    </svg>
  );
});

export { GlassIcon };
